import { Exception } from '../../../../core/logic/exception';

export class ThirdPartyNotFoundException extends Exception<never> {
  constructor() {
    super('Tiers non trouvé');
  }
}
